import React from "react"
import styled from "styled-components"
import { StandardContainer } from "../common"

const StyledTextContent = styled(StandardContainer)`
  max-width: 1280px;
  margin: auto;

  p,
  a,
  span,
  b,
  i,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.color && props.color};
    font-weight: 600;
    max-width: 622px;
    margin: 50px auto;
    font-size: 20px;
    font-style: italic;
    line-height: 29px;
    letter-spacing: 0.6px;
  }
`

export const Quote = ({ category, ...rest }) => {
  const { category_color } = category?.document?.data || {}
  const { text } = rest || {}

  return (
    <StyledTextContent color={category_color}>
      <div dangerouslySetInnerHTML={{ __html: text?.html }} />
    </StyledTextContent>
  )
}
